import { getIsSubscribedFromSkuType } from './getIsSubscribedFromSkuType';
/**
 * Get whether or not the current sku is considered 'subscribed'
 * @param skuType consumer sku type
 * @returns true if user does not contain free SKU types, false otherwise.
 */
export var getIsSubscribedUser = function (_a) {
    var consumerInstallConfig = _a.consumerInstallConfig, workloadPublicDataConfig = _a.workloadPublicDataConfig;
    // Users with business licenses are considerd subscribed
    if (workloadPublicDataConfig === null || workloadPublicDataConfig === void 0 ? void 0 : workloadPublicDataConfig.hasBusinessLicense) {
        return true;
    }
    if (!consumerInstallConfig) {
        return false;
    }
    return getIsSubscribedFromSkuType(consumerInstallConfig.currentSkuInfo.skuType);
};
//# sourceMappingURL=getIsSubscribedUser.js.map